import React from 'react';
import PropTypes from 'prop-types';
import classNames from 'classnames';
import { withStyles } from '@material-ui/core/styles';
import FormControlLabel from '@material-ui/core/FormControlLabel';
import MuiSwitch from '@material-ui/core/Switch';
import { styles } from '../../styles/dashboard-styles';

function Switch(props) {
    const { classes } = props;
    return (
        <FormControlLabel
          control={
            <MuiSwitch
              checked={props.checked}
              onChange={props.onChange}
              value={props.value}
            />
          }
          label={props.label}
          className={classes.darkMode}
        />
    );
  }


  Switch.propTypes = {
    classes: PropTypes.object.isRequired,
  };

  export default withStyles(styles)(Switch);



// WEBPACK FOOTER //
// ./src/components/Settings/Switch.js